export const siteConfig = {
  name: "91吃瓜网",
  tagline: "吃瓜群众的必刷入口",
  description: "91吃瓜网官网实时追踪网红明星最新黑料，每日大赛热门视频在线看不停，娱乐圈爆料、社会热点大瓜第一时间更新，想看最新塌房现场就别错过。",
  url: "https://www.91chigua.com",
  logoText: "91吃瓜",
};

export const categories = [
  { slug: "wanghong-heiliao", name: "网红黑料", icon: "ri-spy-line", description: "网红圈最新爆料，黑历史一网打尽" },
  { slug: "mingxing-tafang", name: "明星塌房", icon: "ri-building-2-line", description: "明星翻车现场，塌房第一时间追踪" },
  { slug: "meiri-dasai", name: "每日大赛", icon: "ri-fire-line", description: "每日热门视频大赛，精彩不停歇" },
  { slug: "yule-bagua", name: "娱乐八卦", icon: "ri-chat-smile-2-line", description: "娱乐圈最新八卦，吃瓜不停" },
  { slug: "shehui-redian", name: "社会热点", icon: "ri-global-line", description: "社会热点大瓜，实时追踪更新" },
  { slug: "zhibo-chigua", name: "直播吃瓜", icon: "ri-live-line", description: "直播现场吃瓜，第一手爆料" },
];

export const featuredArticles = [
  {
    id: 1,
    slug: "mou-dingliu-nanyixing-qianshou-xinren",
    title: "某顶流男星深夜牵手神秘女子，疑似新恋情曝光",
    excerpt: "据知情人士爆料，该男星与神秘女子在某高档餐厅共进晚餐后牵手离开，举止亲密。",
    category: "明星塌房",
    categorySlug: "mingxing-tafang",
    image: "https://readdy.ai/api/search-image?query=Warm%20dramatic%20paparazzi%20style%20photography%2C%20luxury%20night%20scene%20with%20amber%20lighting%2C%20celebrity%20gossip%20atmosphere%2C%20mysterious%20silhouettes%20in%20upscale%20restaurant%2C%20soft%20bokeh%20background%2C%20cinematic%20mood%2C%20golden%20warm%20tones%2C%20editorial%20style&width=800&height=1067&seq=featured-article-01&orientation=portrait",
    date: "2026-07-06",
    views: "128.5万",
    hot: true,
  },
  {
    id: 2,
    slug: "zhiming-wanghong-zhibo-fanche-xianchang",
    title: "知名网红直播翻车现场，口误暴露真实身份引热议",
    excerpt: "该网红在直播中无意间说漏嘴，暴露了自己包装人设背后的真实身份，引发粉丝大规模脱粉。",
    category: "网红黑料",
    categorySlug: "wanghong-heiliao",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%2C%20warm%20ring%20light%20glow%2C%20shocked%20expression%20atmosphere%2C%20digital%20screen%20reflections%2C%20cinematic%20moody%20lighting%2C%20social%20media%20drama%20vibe%2C%20golden%20amber%20tones%2C%20behind%20the%20scenes%20theme&width=800&height=1067&seq=featured-article-02&orientation=portrait",
    date: "2026-07-06",
    views: "95.2万",
    hot: true,
  },
  {
    id: 3,
    slug: "mou-nvxing-bei-baochu-shuiwuwen",
    title: "某女星被曝税务问题，工作室紧急发声明回应",
    excerpt: "网友爆料某一线女星存在严重税务问题，工作室连夜发布律师函否认，但网友扒出更多证据。",
    category: "明星塌房",
    categorySlug: "mingxing-tafang",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20scandal%20scene%2C%20luxury%20office%20with%20tense%20atmosphere%2C%20legal%20documents%20on%20desk%2C%20warm%20golden%20lighting%2C%20cinematic%20mood%2C%20soft%20shadows%2C%20celebrity%20crisis%20theme%2C%20amber%20and%20dark%20tones&width=800&height=1067&seq=featured-article-03&orientation=portrait",
    date: "2026-07-05",
    views: "210.8万",
    hot: true,
  },
  {
    id: 4,
    slug: "wangluo-dasai-xinji-yuanchuang",
    title: "网络大赛黑幕曝光，选手自曝被要求配合剧本演戏",
    excerpt: "某热门网络选秀大赛被参赛选手实名举报存在剧本安排，节目组操控比赛结果。",
    category: "每日大赛",
    categorySlug: "meiri-dasai",
    image: "https://readdy.ai/api/search-image?query=Reality%20show%20competition%20backstage%20scene%2C%20dramatic%20warm%20spotlight%20lighting%2C%20tension%20and%20controversy%20atmosphere%2C%20golden%20amber%20tones%2C%20cinematic%20behind%20the%20scenes%20vibe%2C%20theatrical%20mood&width=800&height=1067&seq=featured-article-04&orientation=portrait",
    date: "2026-07-05",
    views: "87.3万",
    hot: false,
  },
  {
    id: 5,
    slug: "dingliu-aidou-silian-bei-paidao",
    title: "顶流爱豆私联粉丝被拍到，深夜同回公寓",
    excerpt: "有网友拍到某顶流爱豆与粉丝深夜同回公寓的画面，视频在网上疯传引发粉丝震怒。",
    category: "娱乐八卦",
    categorySlug: "yule-bagua",
    image: "https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%2C%20urban%20apartment%20building%20entrance%2C%20warm%20street%20lights%2C%20mysterious%20atmosphere%2C%20celebrity%20secret%20meeting%20vibe%2C%20cinematic%20noir%20style%2C%20amber%20and%20dark%20tones&width=800&height=1067&seq=featured-article-05&orientation=portrait",
    date: "2026-07-04",
    views: "156.7万",
    hot: true,
  },
  {
    id: 6,
    slug: "dawang-hong-bei-zhi-boxu-juanqian",
    title: "大网红被指涉嫌虚假宣传，粉丝集体维权要求退款",
    excerpt: "某拥有千万粉丝的大网红被指虚假宣传带货产品，数百名粉丝联合维权，事件持续发酵。",
    category: "网红黑料",
    categorySlug: "wanghong-heiliao",
    image: "https://readdy.ai/api/search-image?query=Consumer%20rights%20protest%20atmosphere%2C%20crowd%20gathering%20scene%2C%20warm%20dramatic%20lighting%2C%20social%20media%20controversy%20theme%2C%20golden%20amber%20mood%2C%20documentary%20style%20photography%2C%20tension%20and%20drama&width=800&height=1067&seq=featured-article-06&orientation=portrait",
    date: "2026-07-04",
    views: "189.2万",
    hot: false,
  },
];

export const videoArticles = [
  {
    id: 7,
    title: "某男团成员夜店与女子亲密互动",
    views: "326.5万",
    duration: "02:35",
    image: "https://readdy.ai/api/search-image?query=Nightclub%20dramatic%20scene%2C%20warm%20neon%20lighting%2C%20crowded%20dance%20floor%20atmosphere%2C%20celebrity%20party%20vibe%2C%20mysterious%20silhouettes%2C%20cinematic%20amber%20tones%2C%20entertainment%20gossip%20theme&width=640&height=640&seq=video-thumb-01&orientation=squarish",
  },
  {
    id: 8,
    title: "网红直播意外拍到老公出轨证据",
    views: "278.1万",
    duration: "05:18",
    image: "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20interior%2C%20shocked%20reaction%20moment%2C%20warm%20ring%20light%20glow%2C%20dramatic%20reveal%20atmosphere%2C%20golden%20amber%20tones%2C%20reality%20tv%20style%2C%20intimate%20home%20setting&width=640&height=640&seq=video-thumb-02&orientation=squarish",
  },
  {
    id: 9,
    title: "娱乐圈某导演被曝潜规则选角内幕",
    views: "412.3万",
    duration: "08:42",
    image: "https://readdy.ai/api/search-image?query=Film%20casting%20audition%20room%2C%20dramatic%20spotlight%20lighting%2C%20tense%20interview%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20behind%20the%20scenes%20vibe%2C%20entertainment%20industry%20drama&width=640&height=640&seq=video-thumb-03&orientation=squarish",
  },
  {
    id: 10,
    title: "某带货主播被扒售卖假货全程记录",
    views: "195.7万",
    duration: "12:06",
    image: "https://readdy.ai/api/search-image?query=E-commerce%20live%20streaming%20studio%2C%20product%20unboxing%20scene%2C%20warm%20studio%20lighting%2C%20dramatic%20reveal%20atmosphere%2C%20golden%20amber%20tones%2C%20consumer%20expose%20theme%2C%20documentary%20style&width=640&height=640&seq=video-thumb-04&orientation=squarish",
  },
  {
    id: 11,
    title: "明星夫妻综艺录制现场爆发争吵",
    views: "356.2万",
    duration: "03:51",
    image: "https://readdy.ai/api/search-image?query=TV%20show%20recording%20set%2C%20heated%20argument%20scene%2C%20dramatic%20studio%20lighting%2C%20warm%20amber%20tones%2C%20reality%20show%20drama%2C%20cinematic%20tension%2C%20behind%20the%20scenes%20atmosphere&width=640&height=640&seq=video-thumb-05&orientation=squarish",
  },
  {
    id: 12,
    title: "网红被曝学历造假，真实学历曝光",
    views: "234.8万",
    duration: "06:29",
    image: "https://readdy.ai/api/search-image?query=Graduation%20ceremony%20scene%2C%20dramatic%20lighting%2C%20diploma%20and%20documents%2C%20warm%20golden%20tones%2C%20education%20scandal%20theme%2C%20cinematic%20mood%2C%20investigative%20journalism%20style&width=640&height=640&seq=video-thumb-06&orientation=squarish",
  },
];

export const hotTags = [
  "某顶流恋情",
  "网红翻车",
  "直播事故",
  "明星税务",
  "选秀黑幕",
  "私联粉丝",
  "带货假货",
  "学历造假",
  "综艺争吵",
  "导演潜规则",
];